export default "__VITE_ASSET__CS6oaziL__"